import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faCog, faFlask, faCommentAlt, faRss } from '@fortawesome/free-solid-svg-icons'

const Navigation = () => {
  return (
    <div>
      <div className="navigationContainer"></div>
      <div className="navigationContent">
          <input type="checkbox" id="menuToggle" />
          <label htmlFor="menuToggle" className="navigationContent__mobileMenuToggle">
              <img src={'/images/menu.svg'} alt="Menu" />
          </label>

          <div className="navigationContent__titleBox">
              <p className="navigationContent__title"><a href="/">Invently</a></p>
              <p className="navigationContent__who">Creating &amp; producing with imagination</p>
          </div>

          <div className="navigationContent__mobileMenu">
              <ul className="navigationContent__nav">
                  <li>
                    <a href="/">
                      <FontAwesomeIcon icon={faHome} /> Home
                    </a>
                  </li>
                  <li>
                    <a href="/services">
                      <FontAwesomeIcon icon={faCog} /> Services
                    </a>
                  </li>
                  <li>
                    <a href="/products">
                      <FontAwesomeIcon icon={faFlask} /> Products
                    </a>
                  </li>
                  <li>
                    <a href="/get-in-touch">
                      <FontAwesomeIcon icon={faCommentAlt} /> Get in touch
                    </a>
                  </li>
              </ul>

          </div>

          <p className="navigationContent__socialLinks">
              <a href="http://github.com/craigpickles" target="_blank"><img alt="GitHub" src={'/images/github.png'} /></a>
              <a href="http://twitter.com/invently_uk" target="_blank"><img alt="Twitter" src={'/images/twitter.png'} /></a>
              <a href="https://uk.linkedin.com/in/craigpickles1" target="_blank"><img alt="LinkedIn" src={'/images/linkedin.png'} /></a>
          </p>
      </div>
    </div>
  )
}

export default Navigation


